var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMdDomainDiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M42 22a20 20 0 1 1-40 0 20 20 0 0 1 40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M42 22a20 20 0 1 1-40 0 20 20 0 0 1 40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38 18A20 20 0 0 1 6 34C.028 26.038.82 14.896 7.858 7.858S26.038.028 34 6a19.92 19.92 0 0 1 4 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22 2c11.046 0 20 8.954 20 20s-8.954 20-20 20S2 33.046 2 22A19.92 19.92 0 0 1 22 2m0-2C9.85 0 0 9.85 0 22s9.85 22 22 22A22 22 0 0 0 35.2 4.4 21.78 21.78 0 0 0 22 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18 13.12a2 2 0 1 1 0 4 2 2 0 1 1 0-4m0-2a3.771 3.771 0 0 0-1.2.19 4 4 0 0 0 2.4 7.63 4 4 0 0 0-1.2-7.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.34 15.53a2 2 0 0 1 .6 3.9 1.8 1.8 0 0 1-.6.1 2 2 0 1 1 0-4m0-2a4 4 0 1 0 1.2 7.81 4 4 0 0 0-1.2-7.81zM16.47 8.35a2 2 0 1 1-.01 4 2 2 0 0 1 .01-4m0-2a4 4 0 0 0 1.2 7.82 4 4 0 0 0 2.61-5 4 4 0 0 0-3.81-2.8v-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.91 16.71a2 2 0 1 1-.01 4 2 2 0 1 1 .01-4m0-2c-.41 0-.818.06-1.21.18a4 4 0 0 0-2.61 5 4 4 0 0 0 3.81 2.8 4 4 0 0 0 .01-8v.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.4 11.94a2 2 0 1 1 0 4 2 2 0 0 1-.6-3.94c.195-.06.397-.09.6-.09m0-2a3.771 3.771 0 0 0-1.2.19 4 4 0 0 0 1.2 7.81 4 4 0 0 0 3.6-2.12 4 4 0 0 0-3.55-5.85l-.05-.03z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.97,
    cy: 15.12,
    r: 2,
    fill: "#82C45B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.34,
    cy: 17.53,
    r: 2,
    fill: "#82C45B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.9,
    cy: 18.71,
    r: 2,
    fill: "#82C45B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 13.94,
    r: 2,
    fill: "#82C45B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.47,
    cy: 10.35,
    r: 2,
    fill: "#82C45B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.19 36.33a.43.43 0 0 1-.19 0A15.48 15.48 0 0 1 6.5 22a.5.5 0 0 1 1 0 14.49 14.49 0 0 0 6.39 12 14.29 14.29 0 0 0 2.49 1.35.5.5 0 0 1 .27.66.49.49 0 0 1-.46.32zM35.18 15.34a.52.52 0 0 1-.44-.26A14.48 14.48 0 0 0 22 7.5a.5.5 0 1 1 0-1 15.5 15.5 0 0 1 13.62 8.1.51.51 0 0 1-.2.68.5.5 0 0 1-.24.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B87631",
    d: "M21.5 25.16L22 25a5 5 0 0 0 3-3.34l.14-.49a5 5 0 0 1 8.25-2.31l.54.5a5 5 0 0 1 1.43 5.1l-1.47 5.1A5 5 0 0 1 30.51 33l-5.81 1.7a5 5 0 0 1-4.83-1.13 5 5 0 0 1 1.63-8.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30 17.53a5 5 0 0 1 3.39 1.33l.54.5a5 5 0 0 1 1.43 5.1l-1.47 5.1A5 5 0 0 1 30.51 33l-5.81 1.7c-.46.136-.94.204-1.42.2a5 5 0 0 1-3.41-1.33 5 5 0 0 1 1.63-8.41L22 25a5 5 0 0 0 3-3.34l.14-.49A5 5 0 0 1 30 17.53m0-2a7 7 0 0 0-6.78 5.09l-.14.49a3.11 3.11 0 0 1-1.84 2l-.48.18a7.031 7.031 0 1 0 4.48 13.33l5.8-1.71a7 7 0 0 0 4.77-4.8l1.5-5.11a7 7 0 0 0-2-7.13l-.54-.5A7 7 0 0 0 30 15.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1A961",
    d: "M25.17 21.17l-.14.49A5 5 0 0 1 22 25l-.48.18a5 5 0 0 0-2.32 7.62 5 5 0 0 0 2.52-.08L27.51 31a5 5 0 0 0 3.41-3.43l1.47-5.1a5 5 0 0 0-1.11-4.77 5 5 0 0 0-6.11 3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.69 33.58a1 1 0 0 1-.7-.29L20.72 29a1 1 0 1 1 1.41-1.41l4.27 4.27a1 1 0 0 1 0 1.41 1 1 0 0 1-.71.31zM30 31a1 1 0 0 1-.71-.29L25 26.39A1 1 0 0 1 25 25a1 1 0 0 1 1.41 0l4.27 4.27a1 1 0 0 1 0 1.41A1 1 0 0 1 30 31zM32.55 26.92a1 1 0 0 1-.71-.29l-4.26-4.27a1 1 0 0 1 0-1.41A1 1 0 0 1 29 21l4.27 4.26a1 1 0 0 1 0 1.42 1 1 0 0 1-.72.24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdDomainDiet);
export default __webpack_public_path__ + "static/media/ic_md_domain_diet.9868f520082c4cb02f7b1c3252f3d26e.svg";
export { ForwardRef as ReactComponent };